const binding = { modules: {}, dataActions: {} };

    (binding.modules['szf-carousel'] = {
        c: () => require('partner/modules/szf-carousel/szf-carousel.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'szf-carousel',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/szf-carousel'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|szf-carousel|szf-carousel'] = {
                c: () => require('partner/modules/szf-carousel/szf-carousel.view.tsx'),
                cn: '__local__-__local__-szf-carousel'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };